<template>
  <DragPanel
    title="构件"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div class="elem-content-box">
      <div class="tabs-box">
        <div
          :class="`tab-item-box ${isActiveTab('public') ? 'active' : ''}`"
          @click="onTabClick('public')">
          公共构件库
        </div>
        <div
          :class="`tab-item-box ${isActiveTab('private') ? 'active' : ''}`"
          @click="onTabClick('private')">
          我的构件库
        </div>
      </div>
      <div class="elem-data-box">
        <div class="filter-box">
          <div class="common-select-box">
            <el-select
              class="primary-select"
              ref="treeSelect"
              size="small"
              :popper-append-to-body="false"
              :value="selectedNode.nodeName">
              <el-option
                style="height: 100%; padding: 0"
                value="">
                <div class="common-tree-box">
                  <el-tree
                    class="dialog-tree-primary"
                    ref="catalogTree"
                    :data="treeData"
                    :props="defaultProps"
                    node-key="nodeId"
                    highlight-current
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick">
                    <div
                      slot-scope="{ data }"
                      class="custom-node-box">
                      <div class="node-label-box">
                        <div
                          class="node-label text-overflow"
                          :title="data.nodeName">
                          <span>{{ data.nodeName }}</span>
                          <span>{{ data.count ? `(${data.count})` : '' }}</span>
                        </div>
                      </div>
                    </div>
                  </el-tree>
                </div>
              </el-option>
            </el-select>
          </div>
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              v-model="keywords"
              placeholder="请输入构件名称"
              clearable
              @clear="updateDataList"
              @keyup.enter.native="updateDataList">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="updateDataList" />
            </el-input>
          </div>
        </div>
        <div
          v-show="dataList.length"
          class="elem-list-box"
          v-infinite-scroll="handleScroll"
          :infinite-scroll-distance="20">
          <div
            class="list-item-box"
            v-for="(item, index) in dataList"
            :key="index">
            <div class="img-box">
              <img
                v-if="item.thumbnail"
                :src="`${imageBaseUrl}/${item.thumbnail}?token=${getTokenId()}`"
                @error="showImg" />
              <img
                v-else
                src="@/assets/img/no-thumbnail.png" />
              <div class="custom-progress-box">
                <el-progress
                  :show-text="false"
                  :percentage="getProress(item)"
                  color="#07B500" />
              </div>
              <div class="mask-box">
                <div class="icon-box">
                  <icon-svg
                    v-if="!isLoaded(item) && !isLoading(item)"
                    class="icon download"
                    icon-class="icon-xiazai"
                    @click.native="downloadElem(item)" />
                  <icon-svg
                    v-if="!isLoaded(item) && isLoading(item)"
                    class="icon loading"
                    icon-class="ic-jiazaizhong" />
                  <icon-svg
                    v-if="isLoaded(item)"
                    class="icon add"
                    icon-class="icon-fangzhigoujian"
                    @click.native="addEntity(item)" />
                </div>
                <div class="text-box">
                  <span v-if="!isLoaded(item) && !isLoading(item)">
                    载入模板
                  </span>
                  <span v-if="!isLoaded(item) && isLoading(item)">
                    载入中
                  </span>
                  <span v-if="isLoaded(item)"> 放置构件 </span>
                </div>
              </div>
            </div>
            <div
              class="name-box"
              :title="formatName(item.name)">
              <div class="name muti-line-text-overflow">
                {{ formatName(item.name) }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="common-empty-box"
          v-if="!dataList.length">
          <bj-empty
            :image="require('@/assets/img/no-data.png')"
            class="empty-page">
            <template slot="description">
              <div class="text-box empty-text">抱歉，没有找到相关内容</div>
            </template>
          </bj-empty>
        </div>
        <div class="tip-box">
          <span class="dialog-label">目标路径：</span>
          <div
            class="path-name-box muti-line-text-overflow dialog-label"
            :title="formatCurrNodeName()">
            {{ formatCurrNodeName() }}
          </div>
        </div>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'

import { Store } from '@/utils/store'
import { getTokenId } from '@/utils/generalMethods'

import {
  publicElemCatalogService,
  privateElemCatalogService,
  getPublicElemList,
  getPrivateElemList
} from '@/service/interface'

export default {
  data() {
    return {
      imageBaseUrl: window.imageBaseUrl,
      activeTab: 'public',
      treeData: [],
      defaultProps: {
        children: 'nodes',
        label: 'nodeName'
      },
      selectedNode: {},
      keywords: '',
      currentPage: 1,
      pageSize: 100,
      dataList: [],
      loadingElems: [],
      loadedElemIds: []
    }
  },
  props: {
    isPosEditMode: Boolean,
    currDataSetFolder: Object,
    updateElemEditMode: Function,
    updateCurrEditElem: Function,
    savePosition: Function,
    preLoadElem: Function,
    closeElementPanel: Function
  },
  components: {
    DragPanel
  },
  mounted() {
    this.initData('public')

    this.$eventManage.on('dataSetLoadFinish', this.onDataSetLoadFinish)
  },
  beforeDestroy() {
    this.$eventManage.off('dataSetLoadFinish', this.onDataSetLoadFinish)
  },
  methods: {
    initData(elemType) {
      this.queryCataLogTreeData(elemType).then(catalogTreeData => {
        this.treeData = catalogTreeData
        this.$nextTick(() => {
          let nodeData = this.treeData[0]
          this.handleNodeClick(nodeData)
        })
      })
    },
    onTabClick(tabName) {
      this.activeTab = tabName
      this.selectedNode = {}
      this.currentPage = 1
      this.clearFilter()
      this.initData(tabName)
    },
    clearFilter() {
      this.keywords = ''
    },
    handleNodeClick(nodeData) {
      if (nodeData.nodeId === this.selectedNode.nodeId) return

      this.$refs.catalogTree.setCurrentKey(nodeData.nodeId)
      this.selectedNode = nodeData

      this.clearFilter()
      this.updateDataList()

      this.$refs.treeSelect.visible = false
    },
    updateDataList() {
      this.queryElementList().then(response => {
        let { dataList } = response
        this.dataList = dataList
      })
    },
    handleScroll() {
      if (this.allDataLoaded) return
      if (this.dataList.length < this.pageSize) return
      this.currentPage++
      this.queryElementList().then(response => {
        let { dataList } = response
        if (dataList.length) {
          this.dataList = [...this.dataList, ...dataList]
        } else {
          this.allDataLoaded = true
        }
      })
    },
    downloadElem(elemInfo) {
      const BlackHole3D = window.BlackHole3D

      let isMeasure = BlackHole3D.Measure.getCurState()
      if (isMeasure) {
        this.$message.warning('当前正处于测量状态，请退出测量后再添加构件')
        return
      }

      let find = this.loadingElems.find(
        el => el.dataSetId === elemInfo.dataSetId
      )
      if (!find) {
        let obj = {
          dataSetId: elemInfo.dataSetId,
          progress: 0
        }
        this.loadingElems.push(obj)
        if (!this.timer) {
          this.timer = setInterval(this.refreshDownLoadPregress, 100)
        }
      }

      this.preLoadElem([elemInfo])
    },
    onDataSetLoadFinish(eventInfo) {
      let loadedElems = eventInfo.loadedElems
      if (!loadedElems.length) return
      loadedElems.forEach(item => {
        let dataSetId = item.dataSetId
        let findIndex = this.loadingElems.findIndex(
          el => el.dataSetId === dataSetId
        )
        if (findIndex !== -1) {
          this.loadingElems.splice(findIndex, 1)
        }

        let find = this.loadedElemIds.find(el => el === dataSetId)
        if (!find) {
          this.loadedElemIds.push(dataSetId)
        }
      })
    },
    addEntity(elemInfo) {
      this.checkBeforeAdd().then(checkResult => {
        if (checkResult) {
          this.updateElemEditMode('single')
          this.updateCurrEditElem(elemInfo)

          const BlackHole3D = window.BlackHole3D
          let isEditting = BlackHole3D.Entity.getEditMode()
          if (!isEditting) {
            BlackHole3D.Entity.enterEditMode()
            BlackHole3D.Probe.setProbeMode(1)
          }

          let dataSetId = elemInfo.dataSetId
          let resId = dataSetId.replaceAll('-', '')
          let typeNames = BlackHole3D.Entity.getAllTypeNames(resId)
          if (typeNames.length) {
            BlackHole3D.Entity.setMultiAddEntity(false)
            BlackHole3D.Entity.setMouseAddEntity(resId, typeNames[0])
          }
        }
      })
    },
    checkBeforeAdd() {
      return new Promise(resolve => {
        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Entity.exitEditMode()

        let isMeasure = BlackHole3D.Measure.getCurState()
        if (isMeasure) {
          this.$message.warning('当前正处于测量状态，请退出测量后再添加构件')
          resolve(false)
          return
        }

        if (this.isPosEditMode) {
          let msg = '当前正处于位置编辑状态，是否退出并保存当前位置信息'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.savePosition()
              resolve(false)
            })
            .catch(() => {
              this.$message.info('取消退出')
              resolve(false)
            })
          return
        }

        resolve(true)
      })
    },
    isActiveTab(tabName) {
      return this.activeTab === tabName
    },
    refreshDownLoadPregress() {
      if (!this.loadingElems.length) {
        clearInterval(this.timer)
        this.timer = null
      }

      this.loadingElems.forEach(item => {
        let deltaProgerss = parseInt(Math.random() * 25)
        item.progress += deltaProgerss
        if (item.progress >= 100) {
          if (this.isLoaded(item)) {
            item.progress = 100
          } else {
            item.progress = 99
          }
        }
      })
    },
    getProress(elemInfo) {
      if (this.isLoaded(elemInfo)) {
        return 100
      }

      let find = this.loadingElems.find(
        el => el.dataSetId === elemInfo.dataSetId
      )
      if (find) {
        return find.progress
      } else {
        return 0
      }
    },
    isLoaded(elemInfo) {
      return this.loadedElemIds.includes(elemInfo.dataSetId)
    },
    isLoading(elemInfo) {
      let find = this.loadingElems.find(
        el => el.dataSetId === elemInfo.dataSetId
      )
      if (find) {
        return true
      } else {
        return false
      }
    },
    showImg(img) {
      img.target.src = require('@/assets/img/no-thumbnail.png')
    },
    formatName(name) {
      return name.substring(0, name.lastIndexOf('.'))
    },
    formatCurrNodeName() {
      let levelPathName = ''

      if (Object.keys(this.currDataSetFolder).length) {
        levelPathName = this.currDataSetFolder.levelPathName
      } else {
        levelPathName = '构件根目录'
      }

      return levelPathName
    },
    queryCataLogTreeData(elemType) {
      return new Promise(resolve => {
        let catalogTreeRootId = '00000000-0000-0000-0000-000000000000'
        let params = {
          parentId: catalogTreeRootId,
          returnCount: true,
          lazyLoading: false
        }
        if (elemType === 'public') {
          publicElemCatalogService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let catalogData = [
                {
                  nodeId: catalogTreeRootId,
                  nodeName: '公共构件',
                  nodeType: 0,
                  count: data.count,
                  nodes: data.nodes
                }
              ]
              resolve(catalogData)
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          let userInfo = Store.userInfo
          params.userId = userInfo.userId
          privateElemCatalogService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let catalogData = [
                {
                  nodeId: catalogTreeRootId,
                  nodeName: '我的构件',
                  nodeType: 0,
                  count: data.count,
                  nodes: data.nodes
                }
              ]
              resolve(catalogData)
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      })
    },
    queryElementList() {
      return new Promise(resolve => {
        let params = {
          parentId: this.selectedNode.nodeId,
          name: this.keywords,
          resultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize
        }
        if (this.activeTab === 'public') {
          params.scopeFilter = 'All'
          params.sortType = 'LastUsedDate'
          getPublicElemList(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let dataList = data.items
              dataList.forEach(item => {
                item.dataSetType = 17
                item.srcDataSetType = 17
                item.srcDataSetId = item.dataSetId
              })
              resolve({ dataList })
            }
          })
        } else {
          let userInfo = Store.userInfo
          params.userId = userInfo.userId
          params.sortType = 'LastUsedDate'
          getPrivateElemList(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let dataList = data.items
              dataList.forEach(item => {
                item.dataSetType = 18
                item.srcDataSetType = 18
                item.srcDataSetId = item.dataSetId
              })
              resolve({ dataList })
            }
          })
        }
      })
    },
    closePanel() {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Probe.setProbeMode(0)
      BlackHole3D.Entity.exitEditMode()

      this.closeElementPanel()
    },
    // 打开其他面板前的校验
    openOtherPanelCheck() {
      return new Promise(resolve => {
        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Probe.setProbeMode(0)
        BlackHole3D.Entity.exitEditMode()

        this.closeElementPanel()
        resolve(true)
      })
    },
    getTokenId
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 360px;
  height: 640px;
  min-width: 360px;
  min-height: 640px;

  /deep/ .content {
    height: calc(100% - 56px);

    .elem-content-box {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 8px 15px;
      font-size: 14px;

      .tabs-box {
        display: flex;
        border-radius: 4px;
        background: var(--attr-tabs-bgColor);

        .tab-item-box {
          margin: 2px;
          flex-grow: 1;
          padding: 5px;
          border-radius: 3px;
          cursor: pointer;
          color: var(--tabs-item-text-color);
        }

        .active {
          color: var(--aside-bg-color);
          background: var(--base-primary-color);
        }
      }

      .elem-data-box {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        height: calc(100% - 36px);

        .filter-box {
          display: flex;
          margin: 10px 0px;

          .common-input-box {
            width: 45%;
            flex-shrink: 0;
            margin-right: 10px;
          }

          .common-select-box {
            flex-grow: 1;
            margin-right: 10px;

            .primary-select {
              width: 100%;

              .el-select-dropdown {
                min-width: 304px !important;
                .common-tree-box {
                  .is-current > .el-tree-node__content {
                    height: auto;
                  }

                  .custom-node-box {
                    height: 26px;
                    .node-label-box {
                      height: 26px;
                      .node-label {
                        height: 26px;
                        line-height: 26px;
                      }
                    }
                  }
                }
              }
            }

            .el-select-dropdown__item {
              background-color: transparent;
            }
          }

          .mode-switch-box {
            margin-left: 10px;
            line-height: 32px;
            cursor: pointer;
          }
        }

        .elem-list-box {
          display: flex;
          height: 100%;
          flex-wrap: wrap;
          align-content: flex-start;
          overflow-y: auto;

          .list-item-box {
            width: 95px;
            margin-right: 10px;
            margin-bottom: 10px;
            background-color: var(--sceneCard-BIM-item-bgColor);
            border-radius: 6px;
            border: 1px solid var(--sceneCard-BIM-item-border-color);

            .img-box {
              position: relative;
              height: 80px;

              &:hover {
                .mask-box {
                  display: block;
                }
              }

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px 4px 0px 0px;
              }

              .custom-progress-box {
                position: absolute;
                bottom: 5px;
                width: 100%;
                padding: 0px 5px;

                .el-progress {
                  .el-progress-bar {
                    .el-progress-bar__outer {
                      background-color: #c6c6c6 !important;
                    }
                  }
                }
              }

              .mask-box {
                display: none;
                position: absolute;
                top: 0px;
                width: 100%;
                height: 100%;
                background: var(--base-bg-dark-color15);

                .icon-box {
                  display: flex;
                  width: 20px;
                  height: 20px;
                  font-size: 14px;
                  margin: 15px auto 5px auto;
                  background: var(--base-primary-bgColor);
                  border-radius: 4px;

                  .icon {
                    margin: 0px auto;
                    color: var(--aside-bg-color);
                  }

                  .download {
                    cursor: pointer;
                  }

                  .add {
                    cursor: pointer;
                  }

                  @keyframes rotate {
                    from {
                      -webkit-transform: rotate(0);
                      transform: rotate(0);
                    }
                    to {
                      -webkit-transform: rotate(360deg);
                      transform: rotate(360deg);
                    }
                  }

                  .loading {
                    animation: rotate 3s linear infinite;
                  }
                }

                .text-box {
                  display: inline-block;
                  font-size: 12px;
                  padding: 5px;
                  border-radius: 5px;
                  background: var(--base-primary-bgColor);
                  color: var(--aside-bg-color);
                }
              }

              .operation-box {
                position: absolute;
                top: 3px;
                right: 3px;

                .icon-box {
                  font-size: 14px;
                  width: 20px;
                  height: 20px;
                  margin-bottom: 5px;
                  background: #959595;
                  cursor: pointer;
                }
              }
            }

            .name-box {
              display: flex;
              align-items: center;
              padding: 5px;
              width: 100%;
              // height: auto;
              border-radius: 0px 0px 4px 4px;

              .name {
                font-size: 12px;
                line-height: 16px;
                -webkit-line-clamp: 2;
                color: var(--sceneCard-BIM-item-text-color);
                text-align: left;
                word-break: break-all;
              }
            }
          }
        }

        .common-empty-box {
          .empty-page {
            :deep(.el-empty__image) {
              img {
                width: 80%;
                height: 80%;
              }
            }
          }

          .text-box {
            margin: auto;
            color: #909399;
            font-size: 14px;
          }
        }
      }

      .tip-box {
        display: flex;
        align-items: center;
        padding: 16px;
        margin: 0 -16px;
        border-top: 1px solid var(--dialog-split-line-color);

        .path-name-box {
          text-align: left;
        }
      }
    }
  }
}
</style>
